import { Result } from 'antd';
import React from 'react';
import { useTranslation } from '../../i18n/useTranslation';

export const UnauthorizedPage = (props: { width?: string }) => {
    const { t } = useTranslation();
    return (
        <>
            <Result
                status="403"
                style={{ width: props?.width }}
                title={t('Unauthorized')}
                subTitle={t('Sorry, you are not authorized to access this page.')}
            />
        </>
    );
};
